/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Action_Next_StepInputs */

const en_ticket_action_next_step = /** @type {(inputs: Ticket_Action_Next_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`next`)
};

const ja_ticket_action_next_step = /** @type {(inputs: Ticket_Action_Next_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次のステップ`)
};

const fr_ticket_action_next_step = /** @type {(inputs: Ticket_Action_Next_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`suivant`)
};

const de_ticket_action_next_step = /** @type {(inputs: Ticket_Action_Next_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nächster`)
};

/**
* | output |
* | --- |
* | "next" |
*
* @param {Ticket_Action_Next_StepInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_action_next_step = /** @type {((inputs?: Ticket_Action_Next_StepInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Action_Next_StepInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_action_next_step(inputs)
	if (locale === "ja") return ja_ticket_action_next_step(inputs)
	if (locale === "fr") return fr_ticket_action_next_step(inputs)
	return de_ticket_action_next_step(inputs)
});